import { Clipboard } from '@capacitor/clipboard'

/**
 * Copies a string to the clipboard.
 * Returns true when the write succeeded, false when it failed.
 */
const copyToClipboard = async (value: string): Promise<boolean> => {
  try {
    await Clipboard.write({ string: value })
    return true
  } catch (error) {
    console.error('Error copying to clipboard:', error)
    return false
  }
}

export { copyToClipboard }
